<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-overlay :value="loader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <div class="d-flex justify-end">
      <v-btn 
        color="brand onBrand--text"
        dark
        small
        style="margin-right:0.5em;border-radius:8px"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>
        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Misc and Other Fees Payment</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <br>
            <v-row justify="center">
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete color="#0F2027" dense rounded required v-model="selected_ay" item-value="ay_id"
                        :items="academic_year_list" item-text="academicyear" label="Select Academic Year" outlined
                        />
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-combobox color="#0f2027" rounded v-model="selected_children" :items="children"
                        label="Select Child" item-text="name" outlined dense prepend-icon="mdi-account-child-circle"
                        @click="show = false"></v-combobox>
                </v-col>
                <v-col cols="12" sm="1" md="1" class="pt-1">
                    <v-btn class="button" @click="getDetails()">Proceed</v-btn>
                </v-col>
            </v-row>
            <span v-if="show">
                <v-row justify="center">
                    <v-col cols="12" class="text-center">
                        <div class="py-2 px-4 d-inline-flex align-center rounded-lg"
                            style=" font-size:16px;">
                        <span><b>AY:</b> {{ current_ay }}</span>
                        <v-divider vertical class="mx-3"></v-divider>
                        <span><b>Standard:</b> {{ leaner_std }}</span>
                        <v-divider vertical class="mx-3"></v-divider>
                        <span><b>Division:</b> {{ leaner_div }}</span>
                        </div>
                    </v-col>
                </v-row>
                <v-row v-if="misc_fees_list != ''" dense justify="center">
                    <v-col sm="4" md="4">
                        <v-autocomplete clearable rounded outlined dense v-model="search_category"
                            @change="selectAll = false" :items="misc_fees_list" item-text="miscfeescategory"
                            label="Search Category" persistent-hint single-line></v-autocomplete>
                    </v-col>
                </v-row>
                <v-row class="flash" v-else dense justify="center">
                    <strong>Misc fee not configure please contact admin of school</strong>
                </v-row>
                <!-- <div class="text-uppercase text-bold">id selected: {{selected}}</div> -->
                <v-simple-table dense class="elevation-1 mytable" v-if="feelist != '' && search_category != null">
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th>
                                    <label class="form-checkbox">
                                        <input type="checkbox" v-model="selectAll" @click="select" />
                                        <i class="form-icon"></i>
                                    </label>
                                </th>
                                <th>Sr. No.</th>
                                <th>Amount</th>
                                <th>Misc</th>
                                <th>Misc Category</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in feelist" :key="index">
                                <td>
                                    <label class="form-checkbox">
                                        <input type="checkbox" :value="item.id" v-model="selected" />
                                        <i class="form-icon"></i>
                                    </label>
                                </td>
                                <td>{{ item.srno }}</td>
                                <td>{{ item.amount }}</td>
                                <td>{{ item.miscfeesmaster }}</td>
                                <td>{{ item.miscfeescategory }}</td>
                                <td>
                                    <span v-if="item.pay == false">
                                        <strong>Already Paid</strong>
                                    </span>
                                    <span v-else>
                                        <form :action="url" @submit="payment" v-if="pgs.includes('PayTM')" name="paytmform" method="POST">
                                            <input type="hidden" :value="item.orgid" name="orgid" />
                                            <input type="hidden" :value="item.tenantid" name="tenantid" />
                                            <input type="hidden" :value="item.uid" name="uid" />
                                            <input type="hidden" :value="item.learner_id" name="studid" />
                                            <input type="hidden" :value="item.amount" name="fee_amount" />
                                            <input type="hidden" :value="item.ay" name="ay" />
                                            <input type="hidden" :value="'Misc - ' + item.miscfeesmaster" name="purpose" />
                                            <input type="hidden" :value="item.id" name="json_pre_trans_data" />
                                            <input type="hidden" :value="item.hash_val" name="hash_val" />
                                            <v-btn small class="button" type="submit" :loading="loader">Proceed</v-btn>
                                        </form>
                                        <form :action="razorpay_url" v-if="pgs.includes('RAZORPAY')" @submit="payment" name="paytmform"  method="POST">
                                            <input type="hidden" :value="item.orgid" name="orgid" />
                                            <input type="hidden" :value="item.tenantid" name="tenantid" />
                                            <input type="hidden" :value="item.uid" name="uid" />
                                            <input type="hidden" :value="item.learner_id" name="studid" />
                                            <input type="hidden" :value="item.ay" name="ay"/>
                                            <input type="hidden" :value="item.amount" name="fee_amount"/>
                                            <input type="hidden" :value="'Misc - ' + item.miscfeesmaster" name="purpose"/>
                                            <input type="hidden" :value="item.id" name="json_pre_trans_data"/>
                                            <input type="hidden" :value="item.hash_val" name="hash_val"/>    
                                            <input type="hidden" value="MISC" name="payment_type"/>    
                                            <v-btn class="button" :loading="loader" v-if="item.amount != 0" type="submit">Pay Online [RAZORPAY]</v-btn>
                                        </form>
                                        <v-btn  small v-if="pgs.includes('BillDesk')" :loading="loader" class="button" @click="payWithBillDesk(item)">Proceed [BILLDESK]</v-btn>
                                        
                                        <v-btn small class="button" v-if="pgs.includes('PayU')"  :disabled="item.amount == 0" :loading="loader"
                                         @click="payWithPayU(item.orgid,item.ay,item.tenantid,item.uid,
                                            item.learner_id,item.amount,item.id,item.hash_val)">
                                            Pay Online[PayU]
                                        </v-btn>
                                        <v-btn small class="button" v-if="pgs.includes('CCAVENUE')"
                                            @click="initiateMiscCCAvenuePayment(item.orgid,item.ay,item.tenantid,item.uid,
                                            item.learner_id,item.amount,item.id,item.hash_val)" 
                                            :loading="loader" :disabled="item.amount == 0">Pay Online [CCAVENUE]</v-btn>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
                <center>
                    <v-btn small class="button" v-if="selected != '' && search_category != null"
                        @click="getAmountDetails(selected)">Get Amount Details</v-btn>
                </center>
                <span v-if="show_details && selected != '' && search_category != null">
                    <center>
                        <span v-for="(s, index) in miscfeesmaster" :key="index">{{ index + 1 }}.{{ s }} <br /></span>
                    </center>
                    <center><strong> Total Amount - </strong>{{ amount }}</center>
                    <v-row justify="center">
                        <form :action="url" @submit="payment" v-if="pgs.includes('PayTM')"  name="paytmform" method="POST">
                            <input type="hidden" :value="orgid" name="orgid" />
                            <input type="hidden" :value="tenantid" name="tenantid" />
                            <input type="hidden" :value="uid" name="uid" />
                            <input type="hidden" :value="learner_id" name="studid" />
                            <input type="hidden" :value="amount" name="fee_amount" />
                            <input type="hidden" :value="ay" name="ay" />
                            <input type="hidden" :value="'Fees For- ' +miscfeesmaster" name="purpose" />
                            <input type="hidden" :value="id" name="json_pre_trans_data" />
                            <input type="hidden" :value="hash_val" name="hash_val" />
                            <v-btn small class="button" type="submit" :loading="loader">Proceed [PayTM]</v-btn>
                        </form>
                        <form :action="razorpay_url" v-if="pgs.includes('RAZORPAY')" @submit="payment" name="paytmform"  method="POST">
                            <input type="hidden" :value="orgid" name="orgid" />
                            <input type="hidden" :value="tenantid" name="tenantid" />
                            <input type="hidden" :value="uid" name="uid" />
                            <input type="hidden" :value="learner_id" name="studid" />
                            <input type="hidden" :value="ay" name="ay"/>
                            <input type="hidden" :value="amount" name="fee_amount"/>
                            <input type="hidden" :value="'Fees For- ' + item.miscfeesmaster" name="purpose"/>
                            <input type="hidden" :value="id" name="json_pre_trans_data"/>
                            <input type="hidden" :value="hash_val" name="hash_val"/>    
                            <input type="hidden" value="MISC" name="payment_type"/>    
                            <v-btn class="button" :loading="loader" v-if="item.amount != 0" type="submit">Pay Online [RAZORPAY]</v-btn>
                        </form>
                        <v-btn  small v-if="pgs.includes('BillDesk')" :loading="loader" class="button" @click="payMultipleWithBillDesk()">Proceed [BILLDESK]</v-btn>
                         <v-btn small class="button" v-if="pgs.includes('CCAVENUE')"
                                            @click="initiateMiscCCAvenuePayment(orgid,ay,tenantid,uid,
                                            learner_id,amount,id,hash_val)" 
                                            :loading="loader">Proceed [CCAVENUE]</v-btn>

                         <v-btn small class="button" v-if="pgs.includes('PayU')"
                                            @click="payWithPayU(orgid,ay,tenantid,uid,
                                            learner_id,amount,id,hash_val)" 
                                            :loading="loader">Proceed [PayU]</v-btn>
                    </v-row>
                </span>

                  <form v-if="pu_url"
                        ref="payuForm"
                        :action="pu_url"
                        method="post"
                    >
                        <input type="hidden" name="firstname" :value="payu_data.firstname" />
                        <input type="hidden" name="lastname" :value="payu_data.lastname" />
                        <input type="hidden" name="surl" :value="payu_data.surl" />
                        <input type="hidden" name="phone" :value="payu_data.phone" />
                        <input type="hidden" name="key" :value="payu_data.key" />
                        <input type="hidden" name="hash" :value="payu_data.hash" />
                        <input type="hidden" name="curl" :value="payu_data.curl" />
                        <input type="hidden" name="furl" :value="payu_data.furl" />
                        <input type="hidden" name="txnid" :value="payu_data.txnid" />
                        <input type="hidden" name="productinfo" :value="payu_data.productinfo" />
                        <input type="hidden" name="udf1" :value="payu_data.udf1" />
                        <input type="hidden" name="udf2" :value="payu_data.udf2" />
                        <input type="hidden" name="udf3" :value="payu_data.udf3" />
                        <input type="hidden" name="udf4" :value="payu_data.udf4" />
                        <input type="hidden" name="udf5" :value="payu_data.udf5" />
                        <input type="hidden" name="drop_category" value="EMI" />
                        <input type="hidden" name="amount" :value="payu_data.amount" />
                        <input type="hidden" name="email" :value="payu_data.email" />
                    </form>
            </span>
        </v-card>
        <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span style="color:black">Other Fee Payment Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/DiFrIlgyzxg?si=PsFkB28XvNcXEXpj"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
</template>
<script>
  import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
      data: () => ({
          child_info: null,
        //   extraBreadcrumbItems: [


        //   ],
        //   breadcrumbClass: "breadcrumb-style1",
          children: [],
          selected_install: [],
          get_component_installmet_list: [],
          show: false,
          selected_children: "",
          child_notice: null,
          snackbar_msg: "",
          videoDialog:false,
          color: "",
          snackbar: false,
          loader: true,
          current_ay: "",
          search: "",
          s3url: "",
          misc_fees_list: [],
          leaner_div: null,
          leaner_std: null,
          academic_year_list: [],
          selected_ay: null,
          singleSelect: false,
          selectedTasks: [],
          selected: [],
          selectAll: false,
          url: "",
          url_multiple: "",
          //multiple online fields
          ay: null,
          id: null,
          amount: null,
          miscfeesmaster: null,
          learner_div_id: null,
          learner_id: null,
          tenantid: null,
          orgid: null,
          hash_val: null,
          uid: null,
          show_details: false,
          search_category: null,
          headers: [
              { text: "Sr. No.", value: "srno", sortable: false },
              { text: "Misc", value: "miscfeesmaster", sortable: false },
              { text: "Amount", value: "amount", sortable: false },
              { text: "Action", value: "action", sortable: false },
          ],
          razorpay_url:null,
          pgs:[],
          billdeskMsg: null,
          payuInitiateUrl:null,
          pu_url:null,
          returnURL:null,
        payu_data:null
      }),
      computed: {
          feelist() {
              function compare(a, b) {
                  if (a.name < b.name) return -1;
                  if (a.name > b.name) return 1;
                  return 0;
              }
              if (!this.search_category) return this.misc_fees_list.sort(compare);
              return this.misc_fees_list.filter((tbdata) => {
                  //  alert(tbdata.course_name)
                  return tbdata.miscfeescategory.toLowerCase().indexOf(this.search_category.toLowerCase()) >= 0;
              });
          },
      },
      created() {
          // this.url=process.env.VUE_APP_API_URL + "/paymentGatewayPayTM/paytm"
          this.url = process.env.VUE_APP_API_URL + "/paymentGatewayPayTM/paytm_misc";
          this.razorpay_url=process.env.VUE_APP_API_URL + "/PayementGatewayzRazorPay/razorPayInitiate"
          this.payuInitiateUrl = process.env.VUE_APP_API_URL + "/PayementGatewayPayU/initaitePayUPayment";
          // this.url_multiple = process.env.VUE_APP_API_URL + "/paymentGatewayPayTM/paytm_misc_multiple";
      },
      methods: {
          //payment(id,amount,learner_div_id){
          payment() {
              // alert(id)
              // alert(amount)
              // alert(learner_div_id)
              // const formData={
              //     ld_id:learner_div_id,
              //     misc_id : id,
              //     amt : amount,
              //     data:"misc_id|amt|ld_id",
              //     hash:sha256(misc_id+amt+process.env.VUE_APP_SHA_KEY)
              // }
              var formData = new FormData(paytmform);
              console.log("formData");
              console.log(formData);
              this.loader = false;
          },
           async payWithPayU(org,academicyear_id,tenantid,uid,stud_id,total,id,hash_val){
                let formData = new FormData();
                formData.append("orgid", org);
                formData.append("tenantid", tenantid);
                formData.append("ay", academicyear_id);
                formData.append("uid", uid);
                formData.append("studid", stud_id);
                formData.append("fee_amount", total);
                formData.append("json_pre_trans_data", id);
                formData.append("hash_val", hash_val);
                formData.append("payment_type", "MISC");
                formData.append("purpose", "MISC Fees");
                axios
                  .post(this.payuInitiateUrl, formData)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                       this.payu_data = res.data.payu_data;
                        this.pu_url = res.data.hidden_fields.locatorURL;
                        this.returnURL = res.data.hidden_fields.returnURL;
                        if (this.pu_url) {
                            this.$nextTick(() => {
                                this.$refs.payuForm.submit();
                            });
                        }
                      } else if (res.data.flag == "NO"){
                          this.showSnackbar("#b71c1c", res.data.fsmg);
                      }
                      this.loader = false;
                      })
                  .catch((error) => {
                      console.log(error);
                      this.loader = false;
                      this.showSnackbar("#b71c1c", "Something went wrong");
                  });
            },
           async initiateMiscCCAvenuePayment(org,academicyear_id,tenantid,uid,stud_id,total,id,hash_val){
                let formData = new FormData();
                formData.append("orgid", org);
                formData.append("tenantid", tenantid);
                formData.append("ay", academicyear_id);
                formData.append("uid", uid);
                formData.append("studid", stud_id);
                formData.append("fee_amount", total);
                formData.append("json_pre_trans_data", id);
                formData.append("hash_val", hash_val);
                formData.append("payment_type", "MISC");
                formData.append("purpose", "MISC Fees");
                axios
                  .post("/paymentGatewayCCAvenue/initiateInvoiceCCAvenuePayment", formData)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                        var actionurl = res.data.redirection;
                        var access_code = res.data.merchant_key;
                        var encRequest = res.data.txnToken;
                        if (actionurl && encRequest && access_code) {
                            this.ccavenueRedirection(actionurl, encRequest, access_code);
                        }
                      } else if (res.data.flag == "NO"){
                          this.showSnackbar("#b71c1c", res.data.fsmg);
                      }
                      this.loader = false;
                      })
                  .catch((error) => {
                      console.log(error);
                      this.loader = false;
                      this.showSnackbar("#b71c1c", "Something went wrong");
                  });
            },
            ccavenueRedirection(actionurl, token, access_code) {
              var form = document.createElement("form");
              var encRequest = document.createElement("input");
              var access_codes = document.createElement("input");

              form.method = "POST";
              form.id = "nomsemless";
              form.action = actionurl;

              encRequest.value = token;
              encRequest.name = "encRequest";
              encRequest.id = "encRequest";
              encRequest.type = "hidden";
              form.appendChild(encRequest);

              access_codes.value = access_code;
              access_codes.name = "access_code";
              access_codes.id = "access_code";
              access_codes.type = "hidden";
              form.appendChild(access_codes);

              document.body.appendChild(form);
              document.getElementById("nomsemless").style.display = "none";
              form.submit();
            },
          getAmountDetails(selectedTasks) {
              this.ay = null;
              this.id = null;
              this.amount = null;
              this.miscfeesmaster = null;
              this.learner_div_id = null;
              this.learner_id = null;
              this.tenantid = null;
              this.orgid = null;
              this.hash_val = null;
              this.uid = null;
              this.show_details = false;
              const data = {
                  child: this.selected_children.id,
                  ay: this.selected_ay,
                  selectedTasks: selectedTasks,
              };
              axios
                  .post("/AccountingAndFees/getAmountDetails", data)
                  .then((res) => {
                      if (res.data.flag == "YES") {
                          this.ay = res.data.ay;
                          this.id = res.data.id;
                          this.amount = res.data.amount;
                          this.miscfeesmaster = res.data.miscfeesmaster;
                          this.learner_div_id = res.data.learner_div_id;
                          this.learner_id = res.data.learner_id;
                          this.tenantid = res.data.tenantid;
                          this.orgid = res.data.orgid;
                          this.hash_val = res.data.hash_val;
                          this.uid = res.data.uid;
                          this.show_details = true;
                      }
                  })
                  .catch((error) => {
                      this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                  })
                  .finally(() => {});
          },
          select() {
              this.miscfeesmaster = null;
              this.amount = null;
              this.selected = [];
              if (!this.selectAll) {
                  for (let i in this.feelist) {
                      this.selected.push(this.feelist[i].id);
                  }
              }
              console.log(this.selected);
          },
          getDetails() {
            if(this.selected_ay == null || this.selected_ay == ''){
                this.showSnackbar("error", "Please select Academic Year");
                return;
            }
            if(this.selected_children == null || this.selected_children == ''){
                this.showSnackbar("error", "Please select Child");
                return;
            }
              this.miscfeesmaster = null;
              this.amount = null;
              this.misc_fees_list = [];
              this.show = false;
              this.show_details = false;
              this.selected = [];
              this.search_category = null;
              const formData = {
                  child: this.selected_children.id,
                  ay: this.selected_ay,
              };
              axios
                  .post("/AccountingAndFees/getMiscPaymentInfo", formData)
                  .then((res) => {
                      if (res.data.msg == "200") {
                          this.show = true;
                          this.current_ay = res.data.current_ay;
                          this.leaner_std = res.data.leaner_std;
                          this.leaner_div = res.data.leaner_div;
                          this.misc_fees_list = res.data.misc_fees_list;
                          this.pgs = res.data.pgs;
                          // this.hashval = sha256(learner_id+amt+process.env.VUE_APP_SHA_KEY)
                      }
                  })
                  .catch((error) => {
                      window.console.log(error);
                  })
                  .finally(() => {
                      //close loader
                      this.loader = false;
                      //alert("done")
                  });
          },


          payWithBillDesk(item) {
                this.loader = true;
                this.billdeskMsg = null;

                // let formData = new FormData();
                // formData.append("orgid", item.orgid);
                // formData.append("tenantid", item.tenantid);
                // formData.append("uid", item.uid);
                // formData.append("fee_amount", item.amount);
                // formData.append("studid", item.learner_id);
                // formData.append("json_pre_trans_data", item.id);
                // formData.append("hash_val", item.hash_val);
                // formData.append("ay", item.ay);
                // formData.append("purpose", 'Misc - ' + item.miscfeesmaster);
                // formData.append("payment_type", "MISC");
                 const formData = {
                    fee_amount: item.amount,
                    purpose: 'Misc - ' + item.miscfeesmaster,
                    tenantid: item.tenantid,
                    orgid: item.orgid,
                    ay: item.ay,
                    uid: item.uid,
                    studid: item.learner_id,
                    json_pre_trans_data: item.id,
                    hash_val: item.hash_val,
                    payment_type: "MISC"
                }

                axios.post("/paymentGatewayBillDesk/initiateBillDeskPayment",  formData)
                    .then(res => {
                        if (res.data.msg == "200") {
                            this.billdeskMsg = res.data.billdeskMsg
                            this.startBillDesk()
                        } else {
                            this.showSnackbar("red", res.data.msg || "BillDesk init failed")
                        }
                    })

                    .catch(err => {
                        console.error(err);
                        this.loader = false;
                    })
                    .finally(() => {
                        this.loader = false;
                    })
            },

            payMultipleWithBillDesk() {
                this.loader = true;
                this.billdeskMsg = null;

                // let formData = new FormData();
                // formData.append("orgid", this.orgid);
                // formData.append("tenantid", this.tenantid);
                // formData.append("uid", this.uid);
                // formData.append("fee_amount", this.amount);
                // formData.append("studid", this.learner_id);
                // formData.append("json_pre_trans_data", this.id);
                // formData.append("hash_val", this.hash_val);
                // formData.append("ay", this.ay);
                // formData.append("purpose", 'Fees For- ' + this.miscfeesmaster);
                // formData.append("payment_type", "MISC");

                 const formData = {
                    fee_amount: this.amount,
                    purpose: 'Fees For- ' + this.miscfeesmaster,
                    tenantid: this.tenantid,
                    orgid: this.orgid,
                    ay: this.ay,
                    uid: this.uid,
                    studid: this.learner_id,
                    json_pre_trans_data:Array.isArray(this.id)
                    ? this.id.join(",")
                    : this.id,
                    //json_pre_trans_data: JSON.stringify(this.id),
                    hash_val: this.hash_val,
                    payment_type: "MISC"
                }

                axios.post("/paymentGatewayBillDesk/initiateBillDeskPayment",  formData)
                    .then(res => {
                        if (res.data.msg == "200") {
                            this.billdeskMsg = res.data.billdeskMsg
                            this.startBillDesk()
                        } else {
                            this.showSnackbar("red", res.data.msg || "BillDesk init failed")
                        }
                    })

                    .catch(err => {
                        console.error(err);
                        this.loader = false;
                    })
                    .finally(() => {
                        this.loader = false;
                    })
            },

            startBillDesk() {
                if (!this.billdeskMsg) {
                    this.showSnackbar("red", "Payment data missing")
                    return
                }

                bdPayment.initialize({
                    msg: this.billdeskMsg,
                    options: {
                        enableChildWindowPosting: true,
                        enablePaymentRetry: true,
                        retry_attempt_count: 2
                    }
                });
            },

          showSnackbar(clr, msg) {
              this.snackbar = true;
              this.color = clr;
              this.snackbar_msg = msg;
          },
      },

      mounted() {
          //alert("this.s3url::"+this.s3url)
          axios
              .post("/AccountingAndFees/getChildList")
              .then((res) => {
                  if (res.data.msg == "200") {
                      if ((res.data.status = "SUCCESS")) {
                          this.children = res.data.learners;
                          this.academic_year_list = res.data.academic_year_list;
                      } else {
                          alert(res.data.status_reason);
                      }
                  }
              })
              .catch((error) => {
                  window.console.log(error);
              })
              .finally(() => {
                  //close loader
                  this.loader = false;
                  //alert("done")
              });
      },
  };
</script>

<style scoped>
  tr,
  td,
  th {
      border: 1px solid #e9e7e7;
      text-align: center !important;
  }
  tr,
  tbody {
      border-bottom: 1px solid #ccc;
      border: 1px solid #ccc;
  }

  @media (min-width: 320px) {
      td,
      th {
          display: table-cell !important;
      }
      td + td,
      th + th {
          width: auto;
      }
  }
  v-simple-table {
      white-space: nowrap !important;
      text-align: center;
  }
  .flash {
      animation-name: flash;
      animation-duration: 0.9s;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
      animation-direction: alternate;
      animation-play-state: running;
  }

  @keyframes flash {
      from {
          color: red;
      }
      to {
          color: white;
      }
  }
</style>
